import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { socket } from "../utils/sockets/socket";

// Function to get all sections from all programs
// const getAllSections = (programs) => {
//     return programs.flatMap((program) => program.sections || []);
//   };
  
//   // Function to get all lessons from all programs and sections
//   const getAllLessons = (programs) => {
//     return programs.flatMap((program) =>
//       program.sections.flatMap((section) => section.lessons || [])
//     );
//   };

 
   export const formatRelativeTime = (dateTime) => {
     const now = moment();
     const notificationTime = moment(dateTime);
 
     if (notificationTime.isSame(now, "day")) {
       return `${notificationTime.fromNow()} at ${notificationTime.format("h:mm A")}`;
     } else if (notificationTime.isSame(now.subtract(1, "days"), "day")) {
       return `Yesterday at ${notificationTime.format("h:mm A")}`;
     } else {
       return `${notificationTime.format("Do MMM YYYY")} at ${notificationTime.format("h:mm A")}`;
     }
   };
  
 


export async function getCurrentDeviceInfo() {
  let deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem('device_id', deviceId);
  }

  const getOSType = () => {
    const platform = navigator.platform.toLowerCase();
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) return 'iOS';
    if (/android/.test(userAgent)) return 'Android';
    if (platform.includes('mac')) return 'macOS';
    if (platform.includes('win')) return 'Windows';
    if (platform.includes('linux')) return 'Linux';
    return 'Unknown';
  };

  const deviceType = /Mobi|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
  const osType = getOSType();

  const location = await new Promise((resolve) => {
    if (!navigator.geolocation) {
      return resolve({ latitude: '', longitude: '' });
    }

    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        }),
      () => resolve({ latitude: '', longitude: '' })
    );
  });

  return {
    device_id: deviceId ?? 'unknown',
    device_type: deviceType ??  'unknown',
    os_type: osType ?? 'unknown',
    device_location: location ?? { latitude: '', longitude: '' },
  };
}


// chat thread formate 
export const formatDateTime = (createdAt) => {
  const now = new Date();
  const createdDate = new Date(createdAt);

  // Check if the message was created today
  if (createdDate.toDateString() === now.toDateString()) {
    // If created today, show time in the format "HH:mm"
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }).format(createdDate);
  }

  // Check if the message was created yesterday
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  
  if (createdDate.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  }

  // Otherwise, display the full date
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(createdDate);
};




// ProgramSkeletonCard.jsx
export const ProgramSkeletonCard = () => {
  return (
    <div className="overflow-hidden">
      <div className="w-full mx-auto relative rounded-lg h-full xl:h-[158px] bg-no-repeat border px-7 py-2 mb-4">
        {/* Circle cuts to match the ticket edge */}
        <div className="circle-cutCard -left-5 bg-white top-[50%] -translate-x-1/2"></div>
        <div className="circle-cutCard -right-5 bg-white top-[50%] translate-x-1/2"></div>

        <div className="w-full h-full flex xl:flex-row flex-col justify-between items-center gap-3 md:gap-5 animate-pulse" role="status" aria-busy="true" aria-live="polite">
          {/* Left: image + text */}
          <div className="flex-1 flex gap-5 h-full justify-center items-center md:flex-row flex-col">
            {/* Image placeholder */}
            <div className="h-[115px] shrink-0 w-full md:w-[160px] border overflow-hidden flex justify-center items-center bg-white rounded-[10px] md:order-first order-last">
              <div className="w-full h-full bg-gray-200" />
            </div>

            {/* Text block */}
            <div className="flex-1 flex flex-col gap-3 md:gap-5">
              <div className="border-b pb-4 border-dashed">
                <div className="h-5 w-2/3 bg-gray-200 rounded mb-2" />
                <div className="h-4 w-5/6 bg-gray-200 rounded" />
              </div>

              <div className="flex gap-2 items-center flex-wrap md:flex-nowrap">
                {/* tickets snippet */}
                <div className="flex gap-3 items-center">
                  <div className="h-5 w-5 bg-gray-200 rounded" />
                  <div>
                    <div className="h-4 w-28 bg-gray-200 rounded mb-1" />
                    <div className="h-3 w-32 bg-gray-200 rounded" />
                  </div>
                  <div className="w-[1px] h-10 bg-[#D9D9D9] mx-5" />
                </div>

                {/* date snippet */}
                <div className="flex items-center gap-3">
                  <div className="h-5 w-5 bg-gray-200 rounded" />
                  <div className="h-4 w-40 bg-gray-200 rounded" />
                </div>
              </div>
            </div>
          </div>

          {/* Right: button placeholder */}
          <div className="shrink-0 w-full xl:w-auto">
            <div className="h-[40px] min-w-[200px] w-full rounded-lg bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};

// Handy helper to render multiple skeletons
export const ProgramSkeletonList = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <ProgramSkeletonCard key={i} />
      ))}
    </>
  );
};

export const updateUserActivity = ({ auth, feature_name, sub_feature_name }) => {
  const name =
    auth?.user?.full_name ||
    [auth?.user?.fname, auth?.user?.lname].filter(Boolean).join(" ");
  const email = auth?.user?.email || "Unknown Email";
  const program_type_name = auth?.user?.program_type?.type || "Unknown Program Type";

  const data = {
    user_id: auth?.user?._id,
    name: name || "Unknown User",
    email: email,
    program_type: program_type_name,
    feature_name: feature_name || "Unknown Feature",
    sub_feature_name: sub_feature_name || "",
  };

  if (!socket) {
    console.error("Socket not initialized");
    return;
  }
  // console.log("Emitting userActivity with data:", data);
  socket.emit("userActivity", { activity: data }, (response) => {
    if (response.success) {
      alert(`User activity sent successfully: ${JSON.stringify(data)}`);
    }
  });
};

